const Icon = ({ className, src, alt, ...rest }) => {
    return (
        <img className={className} src={src} {...rest} alt={alt}></img>
    );
};

export default Icon;
